<template>
    <div ref="modal" class="modal" tabindex="-1" role="dialog" @hidden="hidden" id="modal-ngrado">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title text-center"> <b>Crear Nuevo Grado</b> </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body text-center">
              <div class="form-group" :class="{'has-error': validation.hasError('area.nombre')}">
                <div class="input-group input-group-sm">
                  <div class="input-group-addon"> <span class="text-danger">*</span> Nombre</div>
                  <input type="text" v-model.trim="area.nombre" class="form-control" placeholder="Solo letras">
                  <span class="input-group-addon">Nombre del grado</span>
                </div>
                <div class="error" v-if="validation.hasError('area.nombre')"> {{validation.firstError('area.nombre')}} </div>
              </div>

              <div class="form-group" :class="{'has-error': validation.hasError('area.abreviatura')}">
                <div class="input-group input-group-sm">
                  <div class="input-group-addon"> <span class="text-danger">*</span> Abreviatura</div>
                  <input type="text" v-model.trim="area.abreviatura" class="form-control" placeholder="Solo letras">
                  <span class="input-group-addon">Abreviatura del grado</span>
                </div>
                <div class="error" v-if="validation.hasError('area.abreviatura')"> {{validation.firstError('area.abreviatura')}} </div>
              </div>

              <div class="form-group" :class="{'has-error': validation.hasError('area.nivel')}">
                <div class="input-group input-group-sm">
                  <div class="input-group-addon"> <span class="text-danger">*</span> Nivel</div>
                  <input type="number" v-model.number="area.nivel" class="form-control" placeholder="Solo letras">
                  <span class="input-group-addon">Nivel del grado</span>
                </div>
                <div class="error" v-if="validation.hasError('area.nivel')"> {{validation.firstError('area.nivel')}} </div>
              </div>
            </div>
            
            <Alertas 
                ref="alertar" 
                v-bind:msgSuccess="'Creado con exito.'"
                v-bind:msgLoading="'Aplicando...'"
                />
            <div class="modal-footer">
                <button @click="validarCampos" v-if="activo" type="button" class="btn btn-azul">Aceptar</button>
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import Alertas from '@/components/AAlertas.vue'
import gql from 'graphql-tag'
import { Validator } from 'simple-vue-validator'
    export default {
        data(){
            return{
              area:{nombre:null,abreviatura:null,nivel:0},
              activo: true,
            }
        },
        watch:{},
        components:{Alertas},
        validators: {
          'area.nombre'(value){
              return Validator.value(value).required();
          },
        },
        methods:{
            hidden(){
                this.$refs.alertar.cargando();
            },
             validarCampos(){
              this.$validate().then((success) => {
                var obj = window.Object.assign( {},this.area );
                  if (success) {
                    this.submit();
                  }else{
                    window.console.log( "HHHHH",window.stringifyObject(obj) );
                    this.$refs.alertar.invalido();
                  }
              });
            },
            submit(){
                var vue = this;
                vue.$refs.alertar.cargando();
                vue.activo = false;
                var sql = gql`mutation{ createGrado(input:${window.stringifyObject(this.area)}){ok,errors{message}}}`;

                this.$apollo.mutate({
                    mutation: sql,
                }).then((data) => {
                    window.console.log(data);
                    vue.$refs.alertar.success();
                    this.$emit('exito');
                }).catch((error) => {
                    window.console.error(error);
                    vue.$refs.alertar.invalido();
                })
            }
        },
        mounted(){
          var vue = this;
          window.$('#modal-ngrado').on('hide',function(){ vue.area.nombre=null;vue.estado=true; });
        }
    
    }
</script>